import { Capacitor } from '@capacitor/core'
import { PushNotifications } from '@capacitor/push-notifications'
import { AppTrackingTransparency, AppTrackingStatus } from 'capacitor-plugin-app-tracking-transparency'

import { AppSettings } from './plugins/app-settings'
import { isIOS } from './util'

export function openAppSettings () {
  if (!Capacitor.isNativePlatform()) {
    return
  }
  AppSettings.openSettings()
}

export async function isNotificationDisabled () {
  if (Capacitor.isNativePlatform()) {
    if (isIOS()) {
      return (await PushNotifications.requestPermissions()).receive == 'denied'
    } else {
      return !(await AppSettings.getNotificationPermission()).value
    }
  }
  return false
}

let _attState: AppTrackingStatus = 'notDetermined'

export function isAttAllowed () {
  return _attState === 'authorized'
}

async function requestAtt () {
  if (Capacitor.isNativePlatform() && Capacitor.getPlatform() == 'ios') {
    const result = await AppTrackingTransparency.requestPermission()
    _attState = result.status
    if (result.status === 'notDetermined') {
      setTimeout(() => requestAtt(), 1000)
    }
  } else {
    _attState = 'authorized'
  }
}

requestAtt()